// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-checkbox-container {
  display: flex;
  flex-direction: column;
  padding: 3px;
  margin: 3px;
}

.multi-checkbox-option {
  display: flex;
  flex-flow: row;
}

.rectangle {
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
}

.filter {
  padding: 24px;
  border-bottom: 1px solid #f1edf8;
}

.filter-body {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
}

.filter-header {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.filter-title {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  padding-bottom: 8px;
}

.filter-description {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  padding-bottom: 8px;
}

.filter-input {
  border-radius: 4px;
  max-width: 56px;
  max-height: 56px;
}
.filter-input .mat-form-field-infix {
  padding: 5px 0;
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.input-value {
  text-align: center;
}

.input-divider {
  padding-left: 20px;
  padding-right: 20px;
}

.filter-card-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 1;
  margin-top: 1px;
  margin-bottom: 1px;
  flex: 1;
}

.filter-card-content-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.filter-card-tiles-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
}

.filter-close {
  display: flex;
  width: 24px;
}
.text-box {
  border: none;
  outline: none;
}

.text-box :not([type]), input[type=text] {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 90%;
  border: none;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: var(--dark-purple);
}

.text-box-wrapper {
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.filter-tile {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  position: relative;
  margin-left: 0;
  margin-right: 10px;
}

.tile-text {
  min-width: 50px;
  height: 50px;
  align-self: center;
  justify-content: center;
  font-size: 2em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.tile-button {
  float: right;
  align-self: flex-start;
  position: absolute;
  right: 0px;
  top: 0px;
  color: rgba(0, 0, 0, 0.25);
  width: 16px !important;
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  padding: 0;
  background-color: transparent;
}

.tile-text-small {
  min-width: 25px;
  height: 25px;
  align-self: center;
  justify-content: center;
  font-size: 1em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.quick-container {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-self: flex-start;
}

.quick-option {
  white-space: nowrap;
  overflow: hidden;
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 15px;
}

.quick-unselected {
  border-radius: 16px;
  background-color: rgba(134, 109, 255, 0.08);
  border-color: #866dff;
  opacity: 0.6;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
}

.quick-selected {
  border-radius: 16px;
  background-color: #866dff;
  border-color: #866dff;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #ffffff;
}

.search-box span {
  width: 10%;
}

.search-box input {
  margin: 5px;
  width: 80%;
  border: none;
}

.input-content {
  flex-grow: 1;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
  justify-content: center;
}

.pairing-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.pairing-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.pairing-individual-option {
  display: flex;
  max-width: 33%;
}

.active-pairing {
  border-radius: 8px;
  padding: 5px;
  margin-right: 10px;
}

.pairing-container {
  margin: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.pairing-section-container {
  margin-bottom: 10px;
}

.selection-list {
  width: 90%;
}

.radio-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}

.circle-icons {
  font-size: 12px;
}

.workbook_builder_filter_main {
  background-color: #fff;
}

:host ::ng-deep app-word-adjust-filter .input-wrapper {
  justify-content: start;
}
:host ::ng-deep app-word-pairings > div:not(:first-child) {
  margin-top: 32px;
}
:host ::ng-deep app-word-pairings mat-card {
  margin-bottom: 0 !important;
}
:host ::ng-deep app-word-pairings mat-selection-list {
  padding-top: 0;
}
:host ::ng-deep app-word-pairings mat-selection-list .mat-list-item-content {
  padding: 0 !important;
}
:host ::ng-deep app-word-pairings mat-selection-list mat-pseudo-checkbox {
  border: 2px solid #866DFf !important;
}
:host ::ng-deep app-word-pairings mat-form-field .mat-form-field-infix {
  display: block;
  position: relative;
  flex: auto;
  min-width: 0;
  height: 56px;
  border-radius: 4px;
  border: solid 1px rgba(33, 8, 84, 0.32);
  padding: 0 24px !important;
  display: flex;
  align-items: center;
  color: #210854;
}
:host ::ng-deep app-word-pairings mat-form-field label {
  font-size: 13px;
  background-color: white;
  padding: 5px 10px;
  top: 21px !important;
  left: 16px;
  width: auto !important;
  color: #210854;
  opacity: 100%;
  color: #210854 !important;
}
.dark-theme :host ::ng-deep app-word-pairings mat-form-field label {
  background-color: #18112f;
  color: white !important;
}
:host ::ng-deep app-word-pairings mat-form-field .mat-form-field-underline {
  display: none;
}
:host ::ng-deep app-word-pairings mat-form-field .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}
:host ::ng-deep app-word-pairings mat-form-field:not(.mat-form-field-should-float) label {
  top: 28px !important;
  opacity: 32% !important;
}`, "",{"version":3,"sources":["webpack://./src/core/components/workbooks/workbook-builder/word-filters/word-filter.scss","webpack://./src/variable/__variable.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,WAAA;AAHF;;AAKA;EACE,aAAA;EACA,cAAA;AAFF;;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AADF;;AAGA;EAEE,aAAA;EACA,gCAAA;AADF;;AAMA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;AAHF;;AAKA;EACE,aAAA;EACA,sBAAA;EAEA,UAAA;AAHF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EAEA,mBAAA;AAHF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,mBAAA;AAHF;;AAKA;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAKE;EACE,cAAA;AAHJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAGA,OAAA;AAHF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAGA;EACE,aAAA;EAEA,WAAA;AADF;AAMA;EACE,YAAA;EACA,aAAA;AAJF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAMA;EACE,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AALF;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAhBF;;AAkBA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAfF;;AAiBA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EAAA,iCAAA;EACA,UAAA;EACA,6BAAA;AAdF;;AAgBA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAbF;;AAeA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;AAZF;;AAcA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAXF;;AAaA;EACE,mBAAA;EACA,2CAAA;EAEA,qBC1JwB;ED2JxB,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,yBCvKoB;EDwKpB,qBCvKwB;EDwKxB,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AAXF;;AAcA;EACE,UAAA;AAXF;;AAaA;EACE,WAAA;EACA,UAAA;EACA,YAAA;AAVF;;AAYA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AATF;;AAWA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AARF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,cAAA;AAPF;;AASA;EAGE,kBAAA;EACA,YAAA;EACA,kBAAA;AARF;;AAUA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,UAAA;AALF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AAJF;;AAMA;EACE,eAAA;AAHF;;AAKA;EACC,sBAAA;AAFD;;AAWI;EACE,sBAAA;AARN;AAcM;EACE,gBAAA;AAZR;AAeI;EACE,2BAAA;AAbN;AAeI;EACE,cAAA;AAbN;AAcM;EACE,qBAAA;AAZR;AAcM;EACE,oCAAA;AAZR;AAiBM;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAhBR;AAkBM;EACE,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;AAhBR;AAiBQ;EACE,yBAAA;EACA,uBAAA;AAfV;AAkBM;EACE,aAAA;AAhBR;AAmBM;EACE,4BAAA;AAjBR;AAqBQ;EACE,oBAAA;EACA,uBAAA;AAnBV","sourcesContent":["// @import \"../../../../../styles.scss\";\n@import \"../../../../../variable/_variable.scss\";\n// @import \"../../../../../component_variable.scss\";\n.multi-checkbox-container{\n  display: flex;\n  flex-direction: column;\n  // border: 1px $primary-light solid;\n  padding: 3px;\n  margin: 3px;\n}\n.multi-checkbox-option{\n  display: flex;\n  flex-flow: row;\n}\n.rectangle {\n  border-radius: 8px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n}\n.filter{\n  // border-bottom: $whizzimo-border-transparent 1px solid;\n  padding: 24px;\n  border-bottom: 1px solid $border-pale-grey;\n  // background-color: $background;\n  // border-top-left-radius: 8px;\n  // border-top-right-radius: 8px;\n}\n.filter-body{\n  display: flex;\n  flex-flow: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-content: center;\n}\n.filter-header{\n  display: flex;\n  flex-direction: column;\n  // justify-content: center;\n  width: 50%;\n}\n.filter-title{\n  font-size: 20px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  // color: $primary-dark;\n  padding-bottom: 8px;\n}\n.filter-description{\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  // color: rgba($primary-dark, 0.56);\n  padding-bottom: 8px;\n}\n.filter-input{\n  // background-color: $whizzimo-white-darkblue;\n  border-radius: 4px;\n  max-width: 56px;\n  max-height: 56px;\n  // border: solid 1px rgba(33, 8, 84, 0.32);\n  .mat-form-field-infix {\n    padding: 5px 0;\n  }\n}\n.input-wrapper{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.input-value{\n  text-align: center;\n}\n.input-divider{\n  padding-left: 20px;\n  padding-right: 20px;\n  // color: lightgray;\n}\n.filter-card-content{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-grow: 1;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  // max-width: 45%;\n  // width: 50%;\n  flex: 1;\n}\n.filter-card-content-row{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.filter-card-tiles-header{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.filter-close{\n  display: flex;\n  // align-items: center;\n  width: 24px;\n  span{\n    // color: $whizzimo-black-lightblue;\n  }\n}\n.text-box {\n  border: none;\n  outline: none;\n}\n.text-box :not([type]), input[type=\"text\"]{\n  margin-top: 20px;\n  margin-bottom: 20px;\n  width: 90%;\n  border: none;\n  // opacity: 0.32;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  color: var(--dark-purple);\n}\n.text-box-wrapper{\n  border-radius: 4px;\n  // background-color: $whizzimo-white-darkblue;\n  // border: solid 1px $transparent-33;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  .text-box{\n    &::placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n    &::-moz-placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n    &::-webkit-input-placeholder{\n      // color: rgba($whizzimo-black-white,0.87);\n    }\n  }\n}\n.filter-tile{\n  display:flex;\n  flex-direction:column-reverse;\n  justify-content:space-between;\n  position:relative;\n  margin-left: 0;\n  margin-right: 10px;\n}\n.tile-text{\n  min-width:50px;\n  height:50px;\n  align-self:center;\n  justify-content: center;\n  font-size: 2em;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n}\n.tile-button{\n  float:right;\n  align-self:flex-start;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  color: rgba(0, 0, 0, 0.25);\n  width: 16px !important;\n  min-width: fit-content !important;\n  padding: 0;\n  background-color: transparent;\n}\n.tile-text-small{\n  min-width: 25px;\n  height: 25px;\n  align-self:center;\n  justify-content: center;\n  font-size: 1em;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n}\n.quick-container{\n  display: flex;\n  flex-flow: row;\n  flex-wrap: wrap;\n  justify-self: flex-start;\n}\n.quick-option{\n  white-space: nowrap;\n  overflow: hidden;\n  padding: 8px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  margin-right: 15px;\n}\n.quick-unselected{\n  border-radius: 16px;\n  background-color: rgba($fill-button-bg-color, 0.08);\n\n  border-color: $fill-button-border-color;\n  opacity: 0.6;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  // color: $fill-button-font-color;\n}\n.quick-selected{\n  border-radius: 16px;\n  background-color: $fill-button-bg-color;\n  border-color: $fill-button-border-color;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  color: #ffffff;\n}\n\n.search-box span{\n  width: 10%;\n}\n.search-box input{\n  margin: 5px;\n  width: 80%;\n  border: none;\n}\n.input-content{\n  flex-grow: 1;\n  padding-left: 10px;\n  padding-right: 10px;\n  align-items: center;\n  justify-content: center;\n}\n.pairing-wrapper{\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.pairing-options{\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  // justify-content: space-evenly;\n}\n.pairing-individual-option{\n  display: flex;\n  max-width: 33%;\n}\n.active-pairing{\n  // color: black; \n  // background-color: $primary; \n  border-radius: 8px; \n  padding: 5px; \n  margin-right: 10px;\n}\n.pairing-container{\n  margin: 10px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.pairing-section-container{\n  margin-bottom: 10px;\n}\n.selection-list{\n  width: 90%;\n}\n.radio-group{\n  display: flex; \n  flex-direction: row; \n  flex-wrap: wrap; \n  justify-content: space-evenly; \n  align-items: center;\n}\n.circle-icons{\n  font-size: 12px;\n}\n.workbook_builder_filter_main{\n\tbackground-color: #fff;\n}\n\n.mat-menu-item {\n  // color: $whizzimo-black-white; \n}\n\n:host ::ng-deep {\n  app-word-adjust-filter {\n    .input-wrapper {\n      justify-content: start;\n    }\n  }\n\n  app-word-pairings {\n    > div {\n      &:not(:first-child) {\n        margin-top: 32px;\n      }\n    }\n    mat-card {\n      margin-bottom: 0 !important;\n    }\n    mat-selection-list {\n      padding-top: 0;\n      .mat-list-item-content {\n        padding: 0 !important;\n      }\n      mat-pseudo-checkbox {\n        border: 2px solid #866DFf !important;\n      }\n    }\n    mat-form-field {\n      \n      .mat-form-field-infix {\n        display: block;\n        position: relative;\n        flex: auto;\n        min-width: 0;\n        // width: 276px;\n        height: 56px;\n        border-radius: 4px;\n        border: solid 1px rgba(33, 8, 84, 0.32);\n        padding: 0 24px !important;\n        display: flex;\n        align-items: center;\n        color: #210854;\n      }\n      label {\n        font-size: 13px;\n        background-color: white;\n        padding: 5px 10px;\n        top: 21px !important;\n        left: 16px;\n        width: auto !important;\n        color: #210854;\n        opacity: 100%;\n        color: #210854 !important;\n        .dark-theme & {\n          background-color: #18112f;\n          color: white !important;\n        }\n      }\n      .mat-form-field-underline {\n        display: none;\n      }\n\n      .mat-form-field-wrapper {\n        padding-bottom: 0 !important;\n      }\n\n      &:not(.mat-form-field-should-float) {\n        label {\n          top: 28px !important;\n          opacity: 32% !important;\n        }\n      }\n    }\n  }\n}","\n// fonts\n\n$primary-font: \"Roboto\", sans-serif;\n$secondary-font: \"Roboto\", sans-serif;\n$flashcard-font: \"Arial\", sans-serif;\n\n//theme color\n\n$primary-color:#210854;\n$secondary-color:#fff;\n\n// Interface Colors\n$interface-color-darkar:#210854;\n$interface-color-darkar-medium:#481e9f;\n$interface-color-light:#8e70ff;\n$interface-color-light-medium:#866dff;\n$interface-color-light-soft:#e4e2ed;\n$interface-color-soft-darkar:#ff7463;\n$interface-color-soft-medium:#ffb5a0;\n$modal-title-darkar:#0d0223;\n$body-background:#dfdee5;\n$active-account-color:#ffb5a0;\n$ellipsis-icon-color:#cac4d7;\n$paragraph:#777183;\n$newworkbook-bg: rgba(134, 109, 255, 0.04);\n$blank-div-bg-color: rgba(134, 109, 255, 0.08);\n$font-color-light: rgba(13, 2, 35, 0.56);\n\n// Tile Colors\n$grapefruit:#cf1b3a;\n$light-peach:#fec9bf;\n$light-mustard:#ffca5a;\n$light-beige:#ffe79d;\n$soft-green:#00ab44;\n$very-pale-green:#ccf29c;\n$soft-blue:#568aff;\n$pale-sky-blue:#83bfe7;\n$periwinkle:#8e70ff;\n$pale-lilac:#f9c9ff;\n$orangeish:#ff8e42;\n$battleship-grey:#7c7c74;\n$bubblegum:#ff76b8;\n$off-white:#f6efda;\n$c-transparent:rgba(0, 0, 0, 0);\n$c-clear:rgba(0, 0, 0, 0);\n\n//border\n\n$border-dash-image:url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23866DFFFF' stroke-width='2' stroke-dasharray='6%2c 19' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\");\n$border-pale-grey: #f1edf8;\n\n//box shadow\n\n$pad-box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.2);\n$frozen-row-shadow: 0 2px 4px 0 #dfd8f4;\n$box-defult-shadow: 0 4px 16px 0 rgba($interface-color-darkar, 0.08);\n$modal-shadow: 0 12px 32px 0 rgba(12, 1, 35, 0.36);\n\n//button color\n\n$import-btn-font-color:#210854;\n$manage-course-button-bg-color:#ffb5a0;\n$manage-course-button-border-color:#ffb5a0;\n$manage-course-button-font-color:#210854;\n\n$fill-button-bg-color:#866dff;\n$fill-button-border-color:#866dff;\n$fill-button-font-color:#fff;\n\n$transparent-button-bg-color: transparent;\n$transparent-button-font-color: #866dff;\n\n$sharing-done-button-bg-color:#ffb5a0;\n$sharing-done-button-font-color:#210854;\n\n$begin-lesson-button-bg-color:#ffb5a0;\n$begin-lesson-button-font-color:#210854;\n\n$time-reading-score-button-bg-color:#ffb5a0;\n$time-reading-score-button-font-color:#210854;\n\n$registration-login-button-bg-color:#ffb5a0;\n$registration-login-button-font-color:#210854;\n\n$register-button-bg-color:#210854;\n$register-button-font-color:#fff;\n\n//Activity header icon\n\n$read-button: \"assets/img/theme1/book.png\";\n$edit-button: \"assets/img/theme1/pencil.png\";\n$erase-button: \"assets/img/theme1/erase.png\";\n$undo-button: \"assets/img/theme1/undo.png\";\n$keyboard-button: \"assets/img/theme1/keyboard.png\";\n$format-size-button: \"assets/img/theme1/capitalize.png\";\n$visibility-button: \"assets/img/theme1/show.png\";\n$aspect-ratio-button: \"assets/img/theme1/resize.png\";\n$bumping-tiles-button: \"assets/img/theme1/tile-bumping-onoff.png\";\n$delete-button: \"assets/img/theme1/delete.png\";\n$info-button: \"assets/img/theme1/help.png\";\n$color-button: \"assets/img/theme1/color.png\";\n$visibility-hidden: \"assets/img/theme1/hide.png\";\n$assignment-button: \"assets/img/theme1/lines-onoff.png\";\n$search-plus: \"assets/img/theme1/zoom-in.png\";\n$search-minus: \"assets/img/theme1/zoom-out.png\";\n$view-array-button: \"assets/img/theme1/tiles.png\";\n$landscape-button: \"assets/img/theme1/whole-word.png\";\n$folder-button: \"assets/img/page.png\";\n\n//Activity header icon active\n\n$read-button-active: \"assets/img/theme1/book-active.png\";\n$edit-button-active: \"assets/img/theme1/pencil-active.png\";\n$erase-button-active: \"assets/img/theme1/erase-active.png\";\n$undo-button-active: \"assets/img/theme1/undo-active.png\";\n$keyboard-button-active: \"assets/img/theme1/keyboard-active.png\";\n$format-size-button-active: \"assets/img/theme1/capitalize-active.png\";\n$visibility-button-active: \"assets/img/theme1/show-active.png\";\n$aspect-ratio-button-active: \"assets/img/theme1/resize-active.png\";\n$bumping-tiles-button-active: \"assets/img/theme1/tile-bumping-onoff-active.png\";\n$delete-button-active: \"assets/img/theme1/delete-active.png\";\n$info-button-active: \"assets/img/theme1/help-active.png\";\n$color-button-active: \"assets/img/theme1/color-active.png\";\n$assignment-button-active: \"assets/img/theme1/lines-onoff-active.png\";\n$search-plus-active: \"assets/img/theme1/zoom-in-active.png\";\n$search-minus-active: \"assets/img/theme1/zoom-out-active.png\";\n$view-array-button-active: \"assets/img/theme1/tiles-active.png\";\n$landscape-button-active: \"assets/img/theme1/whole-word-active.png\";\n\n//Activity header icon active bg\n\n$read-button-active-bg: #f1eeff;\n\n// Card Width\n\n$card-width-1920: 19.2%;\n$card-width-1680: 18.8%;\n$card-width-1366: 18.8%;\n$card-width-1280: 23.5%;\n$card-width-1024: 31%;\n$workbook-width-content: 23.6%;\n$whizzimolibrary-card: 18.8%;\n$whizzimolibrary-card-1280: 23.5%;\n$whizzimolibrary-card-1024: 31%;\n\n// Card Height\n\n$card-height: 118px;\n$workbook-height-content: 374px;\n\n//Activity header modal bg\n\n$move-bg: \"assets/img/theme1/move-modal.png\";\n\n// common icon\n\n$down-icon: \"assets/img/theme1/down.png\";\n$up-icon: \"assets/img/up.png\";\n$resizable-handle-icon: \"assets/img/theme1/down-white.png\";\n$search-icon: \"assets/img/theme1/search.png\";"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
